/**
 * Shared color constants for Lodestone frontend
 * Single source of truth for colors used across maps, charts, and trip-map modules.
 * Route/marker colors are mirrored in handlers/constants.go — keep in sync.
 */

export const COLORS = {
    // Route/trail
    routeLine: '#4A7C59',
    routeLineHighlight: '#377cfb',

    // Markers
    startMarker: '#4A7C59',
    endMarker: '#ea5234',
    hoverMarker: '#377cfb',
    flyoverMarker: '#22c55e',

    // Chart colors
    primary: '#4A7C59',
    primaryLight: 'rgba(74, 124, 89, 0.15)',
    categories: [
        '#4A7C59', '#66cc8a', '#377cfb', '#ea5234', '#fbbd23',
        '#36d399', '#f87272', '#a78bfa', '#38bdf8', '#fb923c'
    ],
    tooltip: 'rgba(35, 43, 43, 0.9)',
    text: '#78716c',
    grid: 'rgba(0,0,0,0.05)',

    // Theme-aware popup colors (for Mapbox popups)
    popup: {
        light: { text: '#1c1917', subtext: '#78716c', bg: '#ffffff' },
        dark:  { text: '#e7e5e4', subtext: '#a8a29e', bg: '#1c1917' }
    },

    // Landing page fog scene (fixed look, same in light and dark)
    fogScene: {
        skyTop: '#9aa8a2',
        skyBottom: '#55655e',
        ridgeFar: 'rgba(70, 88, 80, 0.55)',
        ridgeMid: 'rgba(48, 64, 57, 0.75)',
        ridgeNear: '#26332d',
        hiker: '#1c2622',
        fogRgb: '225, 230, 227'
    }
};
